import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { Capitales, IGetCapitalesProm } from "@p-p-portafolio/promociones/interfaces/capitales";
import { CapitalesResponse } from "@p-p-portafolio/promociones/interfaces/capitales-response";
import { SwalService } from "@shared/utils/swal.service";
import { CapitalesService } from "@p-p-portafolio/promociones/services/capitales.service";
import { ConfirmDeletionComponent } from "@shared/components/confirm-deletion/confirm-deletion.component";
import { Column } from "@shared/components/generic-table/types/column.type";
import { Row } from "@shared/components/generic-table/types/row.type";
import { CapitalesFormComponent } from "./capitales-form/capitales-form.component";
import Swal from "sweetalert2";

@Component({
    selector: "app-capitales",
    templateUrl: "./capitales.component.html",
    styleUrls: ["./capitales.component.css"],
})
export class CapitalesComponent implements OnInit {
    public columns = [
        { field: "concepto", header: "Capital" },
        { field: "desk", header: "Descripción" },
        { field: "conceptoInteres", header: "Intereses" },
        { field: "desint", header: "Descripción" },
        { field: "actions", header: "Acciones" },
    ];

    public dataSource: any = [];
    public loading: boolean = true;

    promocion: string;
    createForm: boolean = false;
    dataEdit: any;

    constructor(
        public dialog: MatDialog,
        private capitalesService: CapitalesService,
        private swalService: SwalService,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        const routeParams = this.activatedRoute.snapshot.paramMap;
        this.promocion = String(routeParams.get("promocion"));

        this.getDataSource();
    }

    actionHandler(action: "create" | "update" | "delete", rowData?: any) {
        if (action === "create") {
            this.createForm = true;
        }

        if (action === "update") {
            // this.dataEdit = rowData;
            // this.createForm = true;
            this.swalService.warning("Funcionalidad no disponible"); 
        }

        if (action === "delete") {
            this.deleteAction(rowData);
        }
    }

    deleteAction(rowData) {
        Swal.fire({
            title: "Eliminar registro",
            text: "¿Estas seguro de eliminar este registro?",
            icon: "warning",
            showCancelButton: true,
            iconColor: "#d33",
            confirmButtonColor: "#d33",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "No",
            heightAuto: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const payloadUpd: IGetCapitalesProm = {
                    sUsuario: JSON.parse(sessionStorage.getItem("user")),
                    sPromocion: this.promocion,
                    iAccion: 3,
                    iConcepto: rowData.concepto,
                    iConceptoInteres: rowData.conceptoInteres,
                };

                this.capitalesService.update(payloadUpd).subscribe(
                    (res) => {
                        if (res) {
                            this.swalService.success("Registro se ha borrado correctamente");
                            this.getDataSource();
                        } else {
                            this.swalService.error(res.errors[0]);
                        }
                    },
                    (error) => {
                        this.swalService.error(error);
                    }
                );
            }
        });
    }

    goBack() {
        window.history.back();
    }

    handleCloseCreateModal() {
        this.createForm = false;
        this.getDataSource();
    }

    getDataSource() {
        const payload: IGetCapitalesProm = {
            sUsuario: JSON.parse(sessionStorage.getItem("Usser")),
            sPromocion: this.promocion,
            iAccion: 4, //Esta acción es la de Listar
            iConcepto: 0,
            iConceptoInteres: 0,
        };
        this.capitalesService.getAll(payload).subscribe((res) => {
            this.loading = false;
            this.dataSource = res;
        });
    }
}
